import { render, staticRenderFns } from "./change-log.vue?vue&type=template&id=4d682634&scoped=true&"
import script from "./change-log.vue?vue&type=script&lang=js&"
export * from "./change-log.vue?vue&type=script&lang=js&"
import style0 from "./change-log.vue?vue&type=style&index=0&id=4d682634&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d682634",
  null
  
)

export default component.exports